import React, { useRef, useState } from "react";
import { useTranslation } from 'react-i18next'
import { uploadPhoto } from "../../../../utils/data";
import "./index.scss"; 

const ProfilePictureModal = ({ onUpload, onSkip }) => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      setIsUploading(true);
      const res = await uploadPhoto(formData);
      console.log('上传成功', res);
    } catch (error) {
      console.error('上传失败', error);
    } finally {
      setIsUploading(false);
      onUpload()
    }
  };

  return (
    <div className="homepage-modal-overlay">
      <div className="homepage-modal-content">
        <div className="ideas-logo">
          <img src="/assets/images/ideas.svg" alt="Ideas logo" />
        </div>
        <h2 className="homepage-modal-title">
          {t('profile_picture_required_title')}
        </h2>
        <p className="homepage-modal-text">
          {t('profile_picture_required_text')}
        </p>
        <button className="upload-button" disabled={isUploading} onClick={handleButtonClick}>
          <span className="icon-upload"></span> 
          <div className="upload-text">
            {t('upload_profile_picture')}
            <div className="upload-limit-20">{t('limit20mb')}</div>  
          </div>
        </button>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
        <button className="skip-button" onClick={onSkip}>
          {t('skip_for_now')}
        </button>
      </div>
    </div>
  );
};

export default ProfilePictureModal;
